import Vue from 'vue';

export const EventBus = new Vue();
const judgeDeviceType = function () {
  var ua = window.navigator.userAgent.toLocaleLowerCase();
  var isIOS = /iphone|ipad|ipod/.test(ua);
  var isAndroid = /android/.test(ua);
  return {
    isIOS: isIOS,
    isAndroid: isAndroid,
  };
};

const isInputElement = function (e) {
  return e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA';
};

window.addEventListener(
  'focus',
  (e) => {
    if (isInputElement(e)) {
      EventBus.$emit('focus');
    }
  },
  true
);

window.addEventListener(
  'blur',
  (e) => {
    if (isInputElement(e)) {
      EventBus.$emit('blur');
    }
  },
  true
);

window.addEventListener('resize', () => {
  EventBus.$emit('resize');
});

Vue.directive('fixed', {
  bind: function (el) {
    const value = el.style.display;
    const DeviceType = judgeDeviceType();
    if (DeviceType.isIOS) {
      EventBus.$on('focus', () => {
        el.style.display = 'none';
      });
      EventBus.$on('blur', () => {
        el.style.display = value;
      });
    } else {
      let docmHeight = window.innerHeight;
      let realHeight = 0;
      let showFooter = true;

      EventBus.$on('resize', () => {
        realHeight = window.innerHeight;
        showFooter = docmHeight <= realHeight;

        el.style.display = showFooter ? value : 'none';
      });
    }
  },
  unbind() {
    const DeviceType = judgeDeviceType();
    if (DeviceType.isIOS) {
      EventBus.$off('focus');
      EventBus.$off('blur');
    } else {
      EventBus.$off('resize');
    }
  },
});
